"use client"

/**
 * The Leo swap mark — `fa-kit fa-star-christmas-sync`, a custom icon uploaded
 * to the Exxat Font Awesome Kit.
 *
 * "Replace with a better match" is two facts in one action: Leo does it, and
 * what it does is a swap. The Leo star alone says who but not what; the rotate
 * arrows alone say what but not who. The Kit icon carries both, so it is the
 * one mark for this action wherever the action appears.
 *
 * Kept as a component rather than a bare class so the family, the brand colour,
 * and the box stay in one place — a second copy would be the thing that drifts.
 */

import { cn } from "@/lib/utils"

/** Class string, for surfaces whose icon prop is a class rather than a node. */
export const LEO_SWAP_ICON_CLASS = "fa-kit fa-star-christmas-sync"

export function LeoSwapIcon({ className }: { className?: string }) {
  return (
    <i
      className={cn(LEO_SWAP_ICON_CLASS, "w-4 shrink-0 text-center text-brand", className)}
      aria-hidden="true"
    />
  )
}
